<h1 mat-dialog-title>{{ 'UI.ProductCopy.DialogTitle' | translate : titleTranslationParams }}</h1>

<mat-dialog-content>
  <div class="filter-field">
    <label class="ac-form-field-label cf-flex cf-fill">{{ 'UI.Common.Filter.Search' | translate }}</label>
    <mat-form-field appearance="outline" class="cf-flex cf-fill">
      <input type="text" matInput (input)="onFilterInput($event)" [value]="searchString" floatLabel="auto" />
      <mat-icon matSuffix svgIcon="search"></mat-icon>
    </mat-form-field>
  </div>

  <table class="ac-table" mat-table [dataSource]="dataSource">
    <ng-container matColumnDef="name">
      <th class="table-text-column" mat-header-cell *matHeaderCellDef>{{ 'Project.Name' | translate }}</th>
      <td class="table-text-column" mat-cell *matCellDef="let row" data-test="Name">{{ row.name }}</td>
    </ng-container>

    <ng-container matColumnDef="projectNumber">
      <th class="table-text-column" mat-header-cell *matHeaderCellDef>{{ 'Project.ProjectNumber' | translate }}</th>
      <td class="table-text-column" mat-cell *matCellDef="let row" data-test="ProjectNumber">{{ row.projectNumber }}</td>
    </ng-container>

    <ng-container matColumnDef="country">
      <th class="table-text-column" mat-header-cell *matHeaderCellDef>{{ 'Country.Country' | translate }}</th>
      <td class="table-text-column" mat-cell *matCellDef="let row">{{ row.country | translate }}</td>
    </ng-container>

    <!-- Add button for each row -->
    <ng-container matColumnDef="select">
      <th class="table-action-column" mat-header-cell *matHeaderCellDef></th>
      <td class="table-action-column" mat-cell *matCellDef="let row">
        <button
          mat-icon-button
          class="ac-table-button"
          disableRipple="true"
          (click)="onCopy(row)"
          [matTooltip]="'UI.ProductAction.CopyToThisProject' | translate"
        >
          <mat-icon svgIcon="content_copy"></mat-icon>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>

    <tr mat-row *matRowDef="let row; columns: displayedColumns" [attr.data-test]="row.id + '-DataRow'"></tr>
    <!-- mdc classes added, as matNoDataRow styling not working in v15
      See more at: https://github.com/angular/components/issues/26162 -->
    <tr class="mat-row mdc-data-table__row" *matNoDataRow data-test="noDataRow">
      <td class="mat-cell mdc-data-table__cell empty-state-cell" [attr.colspan]="displayedColumns.length">
        {{ 'UI.Common.Filter.NoData' | translate }}
      </td>
    </tr>
  </table>
  <mat-paginator
    class="ac-table-paginator"
    (page)="handlePageEvent($event)"
    [pageSize]="pageSize"
    [pageIndex]="page"
    [length]="totalItems"
    [pageSizeOptions]="pageSizeOptions"
    [showFirstLastButtons]="true"
    aria-label="Select page"
  ></mat-paginator>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <mat-progress-spinner *ngIf="isCopying" [diameter]="20" mode="indeterminate" color="primary"></mat-progress-spinner>
  <button color="accent" mat-stroked-button (click)="dialogRef.close('Canceled')">{{ 'UI.Common.Action.Cancel' | translate }}</button>
</mat-dialog-actions>
